export var getBasketTotalCount = function (basket) {
    return (basket.product_items || [])
        .filter(function (item) { return !item.c_isService; })
        .reduce(function (x, y) { return (x + y.quantity); }, 0);
};
